const [ w, d, mq ] = [ window, document, window.matchMedia('(max-width: 900px)') ]

const init = () => {
$(function () {
  $(".js-accordions-title").on("click", function () {
    $(this).next().slideToggle(300);
    $(this).toggleClass("open", 300);
  });
});
}

export default function PRICE () {
  d.addEventListener('DOMContentLoaded', init );
}